import { TOKEN_TYPE } from "./TokenType.js";

export const LOGICAL_TOKEN_TYPE = {
    ARITHMETIC_OPERAND: [
        TOKEN_TYPE.NUMBER,
        TOKEN_TYPE.DECIMAL
    ]
};